module.exports = __webpack_public_path__ + "img/photo1_1.649569bc.jpg";